import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { Grid, Button, Stack } from '@mui/material';
import FilterBadge from './filter/FilterBadge';
import { Page } from '../../util/Page';
import { SET_FILTER, CLEAR_FILTERS, CLEAR_FILTER } from '../../../redux/actions/actiontypes';

// eslint-disable-next-line
export class FilterDefinition {
  constructor(component, key, label, optionData, filterBuilder, render = (val) => val) {
    this.component = component;
    this.key = key;
    this.label = label;
    this.optionData = optionData;
    this.filterBuilder = filterBuilder;
    this.render = render;
  }

  renderSelector(dispatch) {
    return React.createElement(
      this.component,
      {
        key: this.key,
        label: this.label,
        options: this.optionData,
        onApplyFilter: (v) => this.onApplyFilter(v, dispatch),
      },
      {}
    );
  }

  // eslint-disable-next-line
  onApplyFilter(v, dispatch) {
    const filter = this.filterBuilder(v);
    dispatch({ type: SET_FILTER, filter });
  }
}

const StagingFilterBuilder = ({ filterDefs, filters }) => {
  const dispatch = useDispatch();

  const handleFiltersClear = () => {
    dispatch({ type: CLEAR_FILTERS });
  };

  // eslint-disable-next-line
  const handleFilterClear = (filter) => {
    dispatch({ type: CLEAR_FILTER, filter });
  };

  if (!filterDefs || filterDefs.length <= 0) return <div />;

  return (
    <Grid container>
      <Grid item xs={12}>
        <Page>
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start">
            {filterDefs.map((def) => def.renderSelector(dispatch))}
          </Stack>
        </Page>
      </Grid>
      {filters && filters.length > 0 ? (
        <Grid item xs={12}>
          <Page>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start">
              {filters.map((filter) => (
                <FilterBadge
                  key={filter.key()}
                  filterDef={filterDefs.find((def) => def.key === filter.key())}
                  value={filter.stringify()}
                  onClick={() => handleFilterClear(filter)}
                />
              ))}
              <Button style={{ minWidth: 100 }} onClick={handleFiltersClear}>
                <u>CLEAR ALL</u>
              </Button>
            </Stack>
          </Page>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default connect(
  ({
    entities: {
      staging: { filters },
    },
  }) =>
    // eslint-disable-next-line
    {
      return {
        filters,
      };
    }
)(StagingFilterBuilder);
